export class RelateveDate {

    public name = "today";
    constructor(
        public offset: number
    ){}
}
